import React from 'react';
import classNames from 'classnames';

type DropTargetProps = {
  children?: React.ReactNode;
  onDrop: (files: File[]) => void;
};

function DropTarget({ children = null, onDrop }: DropTargetProps) {
  const [isDragging, setIsDragging] = React.useState(false);

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    // filter out files without type (item.type === '', e.g. directories)
    const newFiles = [...e.dataTransfer.files].filter((item) => !!item.type);
    onDrop(newFiles);
  };

  return (
    <div
      onDragEnter={() => setIsDragging(true)}
      onDragLeave={() => setIsDragging(false)}
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleDrop}
      className={classNames(
        isDragging ? 'hoverable:bg-secondaryButton-light/10' : 'bg-grey-100',
        'relative flex flex-wrap items-center justify-center gap-6 rounded-lg border-2 border-dashed border-grey-600 py-8 px-4 text-text-secondary',
      )}
    >
      {children}
    </div>
  );
}

export default DropTarget;
